module.exports = __webpack_public_path__ + "img/10.17034f12.jpg";